import { FOUNDATION } from "../../../../constants"

export const STORE_TERMS = `${FOUNDATION}_STORE_TERMS`

export const UPDATE_T_AND_C = `${FOUNDATION}_UPDATE_T_AND_C`

export const COPYRIGHT_TRADEMARKS = "Copyrights and Trademarks"

export const LINKS_TO_OTHER_WEBSITES = "Links To Other Web Sites"

export const GOVERNING_LAW = "Governing Law"

export const HOW_DO_WE_OBTAIN_YOUR_CONSENT = "How do we obtain your consent"

export const CHANGES = "Changes"

export const CONTACT_US = "Contact Us"

export const REGISTERED_OFFICE = "Registered Office"

export const PREVIOUS_TERMS_CONDITIONS_VERSIONS = "Previous T&Cs versions"

export const TERMS_ACCEPTED = `${FOUNDATION}_TERMS_ACCEPTED`

export const TERMS_SECTIONS = [
  COPYRIGHT_TRADEMARKS,
  LINKS_TO_OTHER_WEBSITES,
  GOVERNING_LAW,
  HOW_DO_WE_OBTAIN_YOUR_CONSENT,
  CHANGES,
  CONTACT_US,
  REGISTERED_OFFICE,
  PREVIOUS_TERMS_CONDITIONS_VERSIONS,
]
